import type { ImportPhase, ImportFileStatus } from '@/features/chat/hooks/useImport';

/**
 * Import Progress Indicator — pure presentational leaf rendering the current
 * file-import phase, per-file count, and the names of files being imported.
 */
export function ImportProgressIndicator({
  phase,
  progress,
  files,
}: {
  phase: ImportPhase;
  progress: { imported: number; total: number };
  files: ImportFileStatus[];
}) {
  return (
    <div className="import-progress-indicator">
      <span className="import-phase">
        {phase === 'uploading' && 'Uploading files...'}
        {phase === 'parsing' && 'Analyzing files...'}
        {phase === 'executing' && `Importing ${progress.imported}/${progress.total}...`}
      </span>
      {files.length > 0 && (
        <span className="import-files-count">
          {files.map(f => f.filename).join(', ')}
        </span>
      )}
    </div>
  );
}
